<template>
    <div v-if="integrations">
        <b-col sm="12">
            <b-row v-if="$route.params.id !== undefined" >
                <b-col v-if="model">
                    <router-view :model="model" :active="isActive(model.id)"></router-view>
                </b-col>
            </b-row>

            <template v-else>
                <b-row align-content="center" class="mb-5">
                    <b-col offset-md="4" cols="6" md="2" align-self="center"><b-button @click="tab = 'explore'" :pressed="tab == 'explore'" variant="dark" block pill>{{ $t('explore') }}</b-button></b-col>
                    <b-col cols="6" md="2" align-self="center"><b-button @click="tab = 'active'" :pressed="tab == 'active'" variant="dark" block pill :disabled="activeIntegrations.length < 1">{{ $t('available') }} <b-badge> {{ activeIntegrations.length }} </b-badge></b-button></b-col>
                </b-row>
                <b-row>
                    
                    <b-col cols="6" sm="6" md="3" v-for="integration in explore" :key="integration.id" @click="goToIntegration(integration)">
                        <b-card class="tool">
                            <IntegrationIcon :icon="integration.icon" /> 
                            <h4>{{ $translateLabel(integration.label) }} 
                                <br /> 
                                <small>
                                    <b-badge variant="warning" v-if="integration.beta"> beta </b-badge>
                                    <b-badge variant="success" v-if="isOwned(integration)"> {{ $t('owned') }} </b-badge>
                                    <b-badge variant="warning" v-if="isTrial(integration)"> {{ $t('trial') }} </b-badge>
                                    <b-badge variant="success" v-if="getDefaultPrice(integration) <= 0 && !hasMultipleOptions(integration)"> 0$ </b-badge>
                                    <b-badge variant="info" v-else-if="getDefaultPrice(integration) <= 0 && hasMultipleOptions(integration)"> 0$ + </b-badge>
                                    <b-badge variant="info" v-else-if="hasMultipleOptions(integration)"> {{ getDefaultPrice(integration) }}$ + </b-badge>
                                    <b-badge variant="primary" v-else> {{ getDefaultPrice(integration) }}$ </b-badge>
                                </small>
                            </h4>
                        </b-card>
                    </b-col>
                </b-row>
            </template>
        </b-col>
    </div>

    <b-skeleton width="100%" height="250px" v-else animation="throb" />
</template>

<style scoped>
.integration {
    text-align: center;
    cursor: pointer;
}

.integration .badge {
    margin-right: 5px;
}

.integration h4 {
    font-size: 18px;
    margin-top: 10px;
}

a {
    text-decoration: none;
}

.tool {
    text-align: center;
    cursor: pointer;
    font-size: 20px;
}
</style>

<script>
import IntegrationIcon from './Icon'
export default {
    name: 'Integrations',
    components: {
        IntegrationIcon
    },
    data: function() {
        return {
            tabIndex: [0, 0],
            tabHash: ["#explore"],
            model: null,
            integrating: false,
            integrations: null,
            tab: 'explore'
        }
    },
    computed: {
        explore() {
            if (this.tab == "explore") {
                return this.integrations.filter(i => {
                    return !i.disabled && !this.isActive(i.id)
                })
            }

            if (this.tab == "active") {
                return this.activeIntegrations
            }
        },

        subscriptions() {
            return this.$store.getters.getSubscriptions || []
        },

        activeIntegrations() {
            return this.integrations.filter(i => {
                return !i.disabled && this.isActive(i.id)
            })
        }
    },

    methods: {
        getDefaultPrice(integration) {
            // If integration has option_set, use the default option's price
            if (integration.option_set && integration.option_set.items) {
                const defaultOption = integration.option_set.items.find(item => item.default === true);
                if (defaultOption && defaultOption.price) {
                    return defaultOption.price.usd || 0;
                }
                // If no default is found, use the first option
                if (integration.option_set.items.length > 0 && integration.option_set.items[0].price) {
                    return integration.option_set.items[0].price.usd || 0;
                }
            }
            // Fall back to legacy price field
            if (integration.price) {
                return integration.price.usd || 0;
            }
            return 0;
        },

        hasMultipleOptions(integration) {
            return integration.option_set && 
                   integration.option_set.items && 
                   integration.option_set.items.length > 1;
        },

        goToIntegration(integration) {
            this.model = integration
            this.$router.push(integration.settings)
        },

        isActive(id) {
            return this.$store.getters.isIntegrationActive(id)
        },

        isOwned(model) {
            const subs = this.subscriptions
            const integration = subs.find(s => {
                return s.product_id == model.product_id
            })

            return integration !== undefined
        },

        isTrial(model) {
            const integration = this.subscriptions.find(s => {
                return s.product_id == model.product_id
            })

            return integration !== undefined && integration.is_trial
        },
    },
    mounted() {
        let hash = window.location.hash
        this.tabIndex = [0, this.tabHash.indexOf(hash)]

        this.$store.dispatch("fetchIntegrations").then(data => {
            this.integrations = data

            if (this.$route.params.id) {
                let found = data.find(d => {
                    return d.id == this.$route.params.id
                })

                if (found) {
                    this.goToIntegration(found)
                }
            }
        })

        this.$store.dispatch('fetchSubscriptions')
        this.$store.dispatch('fetchTrials')
    }
}
</script>
